import { Icon } from './Icon.tsx';
import { HeroStage } from './HeroStage.tsx';

/**
 * The first screen. The headline is the film's own line, set the way the film
 * sets it — each line rising out of a mask in turn — and the right-hand side is
 * the idea performed once, on a loop (see HeroStage). The buttons are the
 * experience first, then the pilot.
 */
export function LandingIntro() {
  return <section className="hero wrap" aria-labelledby="hero-title">
    <div className="hero-intro">
      <div className="hero-copy">
        <p className="eyebrow rise" style={{ ['--d' as string]: '0ms' }}><span className="small-spark"/>PRODUCT DEMOS, PERSONALLY GUIDED</p>
        <h1 id="hero-title">
          <span className="line"><span style={{ ['--d' as string]: '120ms' }}>They ask.</span></span>
          <span className="line"><span style={{ ['--d' as string]: '240ms' }}>Your agent</span></span>
          <span className="line"><span style={{ ['--d' as string]: '360ms' }}><em>shows them.</em></span></span>
        </h1>
        <div className="hero-description rise" style={{ ['--d' as string]: '620ms' }}>
          <p>Turn a buyer’s question into a guided look at your product.</p>
          <p className="hero-support">Persivo answers with your recorded screens and approved story—so buyers can explore what matters to them.</p>
          <div className="actions">
            <a className="btn solid" href="#product">See the experience <Icon name="arrow-right"/></a>
            <a className="text-link" href="#pilot">Build a demo with us <span aria-hidden="true">↗</span></a>
          </div>
        </div>
      </div>
      <div className="hero-visual rise" style={{ ['--d' as string]: '420ms' }}><HeroStage/></div>
    </div>
  </section>;
}
